import HttpClient from "../services/HttpClient";
import {
  ERROR_MESSAGE,
  APP_URL_REQUEST_MANAGEMENT,
  APP_URL_CONTRACT
} from "../constants";

export const saveLicenceAsync = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const editLicenceAsync = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/update/`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const saveLactationInformationAsync = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/calculate-lactation`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const cancelMaternityLicenceAsync = (data) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/cancel/`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const getFilterMaternityLicence = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/criteria/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getMaternityLicenceDocuments = (licenceId) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/${licenceId}/documents`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const getMaternityLicenceDocumentById = (licenceId, documentId) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/${licenceId}/download-document/${documentId}`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const uploadFilesAsync = (licenceId, documents) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/maternity-licence/${licenceId}/upload-document`,
      documents,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const validatePreviousPregnanteByDocument = (type, number) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}/contract/active/by-document-and-maternity-validation/${number}/${type}`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });

}